import { Component, Input } from '@angular/core';
import { EChartsOption } from 'echarts';

@Component({
  selector: 'app-incident-categories',
  templateUrl: './incident-categories.component.html',
  styleUrls: ['./incident-categories.component.scss'],
})
export class IncidentCategoriesComponent {
  private chartInstance: echarts.ECharts;
  @Input() set chartData(val: any) {
    this.setChartData(val);
  }
  chartOption: EChartsOption;
  setChartData(val: any) {
    const data = [
      { value: val.manualCount, name: 'Manual' },
      { value: val.autoCount, name: 'Automatic' },
    ];
    this.chartOption = {
      tooltip: {
        trigger: 'item',
        formatter: '{b}: {c} ({d}%)',
      },
      legend: {
        bottom: '5%',
        left: 'center',
      },
      series: [
        {
          name: 'Nightingale Chart',
          type: 'pie',
          radius: '50%', // Set the radius for the pie chart
          center: ['50%', '50%'], // Set the center of the pie chart
          data: data,
          roseType: 'radius', // Enable Nightingale chart mode
          label: {
            show: true, // Show labels on the chart
            formatter: '{b} : {c} ({d}%)', // Show labels with name, value, and percentage
          },
          labelLine: {
            show: true, // Show label lines
          },
        },
      ],
    };
  }
}
